import { FC, useState } from 'react';

import type { AgentCoreAttachment } from '@/shared/api/agentCore/agentCoreApi';

import type { AgentChatProps } from '../config';

import { AgentChat } from './AgentChat';
import { AttachmentViewer } from './AttachmentViewer';

type PatientAgentChatProps = Omit<
  AgentChatProps,
  'context' | 'attachmentPreview' | 'onAttachmentPreviewChange'
> & {
  patientID: string;
};

export const PatientAgentChat: FC<PatientAgentChatProps> = ({
  patientID,
  ...props
}: PatientAgentChatProps) => {
  const [preview, setPreview] = useState<AgentCoreAttachment | null>(null);

  return (
    <>
      <AgentChat
        context={{ type: 'patient', patientID }}
        attachmentPreview={preview}
        onAttachmentPreviewChange={setPreview}
        {...props}
      />
      <AttachmentViewer attachment={preview} onClose={() => setPreview(null)} />
    </>
  );
};
